import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getIconicStoriesSliceFilterName,
  getIconicStoriesSliceFilterNames,
  iconicStoriesSliceHasMultipleFilters,
} from '../../selectors';
import { iconicStoriesFilterChangedCreator } from '../../actions';
import CategoryPicker from '../CategoryPicker';

const Filters = ({
  className,
  filterNames,
  hasMultipleFilters,
  onFilterChange,
  selectedFilterName,
}) => (hasMultipleFilters ? (
  <CategoryPicker
    className={className}
    options={[{
      options: filterNames,
      onChange: onFilterChange,
      selected: selectedFilterName,
    }]}
  />
) : null);

Filters.propTypes = {
  className: PropTypes.string,
  filterNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasMultipleFilters: PropTypes.bool.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  selectedFilterName: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
};

Filters.defaultProps = {
  className: undefined,
  selectedFilterName: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  filterNames: getIconicStoriesSliceFilterNames(state, sliceId),
  hasMultipleFilters: iconicStoriesSliceHasMultipleFilters(state, sliceId),
  selectedFilterName: getIconicStoriesSliceFilterName(state, sliceId),
});

const mapDispatchToProps = (dispatch, { sliceId }) => ({
  onFilterChange: filterId => dispatch(iconicStoriesFilterChangedCreator(sliceId, filterId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
